export function defineBooleanValue(
  value: boolean | undefined | null,
  defaultValue: boolean
): boolean {
  return value === undefined || value === null ? defaultValue : value;
}
